import { limitlessAiConstants } from '../../constants';
import { setLocalStorage } from '../../shared/storage';

export const DEFAULT_LIMITLESS_AI_NAME = 'Limitless AI';

export function limitlessAiActivate({
  page, scope, scopeDescription, context, formName,
}) {
  return {
    type: limitlessAiConstants.LIMITLESS_AI_ACTIVATE, page, scope, scopeDescription, context, formName,
  };
}

export function limitlessAiDeactivate() {
  return {
    type: limitlessAiConstants.LIMITLESS_AI_DEACTIVATE,
  };
}

/**
 * Merges additional key/values into the current context and/or updates formName,
 * without re-triggering a full activate/deactivate cycle. Useful for sub-components
 * (e.g. a modal) to tell Limitless AI whether they are currently open/editable.
 */
export function limitlessAiUpdateContext({ context, formName } = {}) {
  return {
    type: limitlessAiConstants.LIMITLESS_AI_UPDATE_CONTEXT, context, formName,
  };
}

/**
 * Requests that the active page perform a quick action on Limitless AI's behalf
 * (e.g. clicking "Add Budget Group"), since the chat panel lives in the Layout/topbar
 * and can't directly reach into page-specific component state/handlers.
 * The page component listens for this via redux and clears it once handled.
 */
export function limitlessAiRequestAction(actionType, actionPayload = null) {
  return {
    type: limitlessAiConstants.LIMITLESS_AI_REQUEST_ACTION, actionType, actionPayload,
  };
}

export function limitlessAiClearPendingAction() {
  return {
    type: limitlessAiConstants.LIMITLESS_AI_CLEAR_PENDING_ACTION,
  };
}

export function limitlessAiSetTrayOpen(trayOpen) {
  return {
    type: limitlessAiConstants.LIMITLESS_AI_SET_TRAY_OPEN, trayOpen,
  };
}

export function limitlessAiSetDisplayName(displayName) {
  const nameToSave = displayName && displayName.trim() ? displayName.trim() : DEFAULT_LIMITLESS_AI_NAME;
  setLocalStorage('limitlessAiDisplayName', nameToSave);
  return {
    type: limitlessAiConstants.LIMITLESS_AI_SET_DISPLAY_NAME, displayName: nameToSave,
  };
}

export function limitlessAiResetDisplayName() {
  setLocalStorage('limitlessAiDisplayName', DEFAULT_LIMITLESS_AI_NAME);
  return {
    type: limitlessAiConstants.LIMITLESS_AI_RESET_DISPLAY_NAME,
  };
}

// eslint-disable-next-line
export const limitlessAiActions = {
  limitlessAiActivate,
  limitlessAiDeactivate,
  limitlessAiUpdateContext,
  limitlessAiRequestAction,
  limitlessAiClearPendingAction,
  limitlessAiSetTrayOpen,
  limitlessAiSetDisplayName,
  limitlessAiResetDisplayName,
};
